// extracted by mini-css-extract-plugin
module.exports = {"flat-onboarding-flow":"_____storeRoute___flat-onboarding-flow__5qJrj"};